import React from "react";

import { JollyRancherChip, type JollyRancherChipColor } from "veneer/Chip";

import { Incident } from "cortex/ui/src/zeus/view/incidents/model";

interface StatusPresentation {
  color: JollyRancherChipColor;
  label: string;
}

export type IncidentStatusValue = NonNullable<Incident["status"]>;

interface IncidentStatusProps {
  status: Incident["status"];
}

const STATUS_PRESENTATIONS: Record<IncidentStatusValue, StatusPresentation> = {
  acknowledged: { color: "orange", label: "Acknowledged" },
  new: { color: "blue", label: "New" },
  on_hold: { color: "red", label: "On Hold" },
};

export const INCIDENT_STATUS_OPTIONS = [
  { label: STATUS_PRESENTATIONS.new.label, value: "new" },
  {
    label: STATUS_PRESENTATIONS.acknowledged.label,
    value: "acknowledged",
  },
  { label: STATUS_PRESENTATIONS.on_hold.label, value: "on_hold" },
] as const;

export function getIncidentStatusChangeComment(
  status: IncidentStatusValue,
): string {
  return `Status changed to ${STATUS_PRESENTATIONS[status].label}.`;
}

export function getStatusFromIncidentStatusChangeComment(
  comment: string,
): IncidentStatusValue | undefined {
  return INCIDENT_STATUS_OPTIONS.find(
    ({ value }) => getIncidentStatusChangeComment(value) === comment,
  )?.value;
}

export default function IncidentStatus({ status }: IncidentStatusProps) {
  if (!status) {
    return null;
  }

  const presentation = STATUS_PRESENTATIONS[status];

  return (
    <JollyRancherChip
      color={presentation.color}
      dataTestId="incident-status"
      label={presentation.label}
    />
  );
}
